import { gql } from 'apollo-angular';
import {
  DASHBOARD_MILESTONES_FRAGMENT,
  PROJECT_DASHBOARD_FETCH_FRAGMENT,
} from './getCommitteeDashboardProject';
export var get_committee_dashboard_by_project = gql`
  ${PROJECT_DASHBOARD_FETCH_FRAGMENT}
  query getCommitteeDashboardByProject(
    $projectid: Mixed
    $milestoneNames: Mixed
  ) {
    pipelineMilestoneDates(
      hasPipeline: { column: NAME, operator: EQ, value: "Closing" }
      hasMilestone: {
        column: NAME
        operator: IN
        value: [
          "Placement Committee Reviewed"
          "Screening Committee"
          "Capital Committee",
        ]
      }
      hasPipelineProjectDates: {
        AND: [{ column: INITIAL_TARGET, operator: EQ, value: false }]
      }
    ) {
      id
      milestone {
        id
        name
      }
      pipelineProjectDates(
        initial_target: false
        where: {
          HAS: {
            relation: "pipelineProject"
            condition: {
              HAS: {
                relation: "project"
                condition: { column: "id", operator: EQ, value: $projectid }
              }
            }
          }
        }
      ) {
        id
        date
        target
        pipelineMilestone {
          milestone {
            name
          }
        }
        pipelineProject {
          project {
            ...ProjectDashBoardData
          }
        }
      }
    }
  }
`;
